(function () {
  const shop = {
    init() {
      this.$el = document.querySelector('.page_wrapper.shop')
      if (this.$el !== null) {
        console.log('Initializing shop...')

        this.$designer = this.$el.querySelector('section.designer')
        this.$categories = this.$el.querySelector('section.categories')
        this.$readMore = this.$el.querySelector('.read_more')
        // because this is the only way to reference it in removeEventList...
        this.catToggleBinded = this.catToggle.bind(this)
        this.readMoreBinded = this.readMore.bind(this)
        this.destroyBinded = this.destroy.bind(this)
        this.resizeBinded = this.resizeHandler.bind(this)

        this.resizeHandler()
        this.setUpListeners()
      }
    },

    setUpMasonry() {
      this.msnry = new Masonry(document.querySelector('.grid'), {
        itemSelector: '.product',
        columnWidth: '.grid-sizer',
        percentPosition: true
      })
    },

    setUpListeners() {
      PubSub.subscribe('page.transitionStartDone', this.destroyBinded)
      window.addEventListener('resize', this.resizeBinded)

      if (this.$readMore !== null) {
        this.$readMore
          .addEventListener('click', this.readMoreBinded)
      } else if (this.$categories !== null) {
        this.$categories
          .querySelector('.menu-item.active')
          .addEventListener('click', this.catToggleBinded)
      }
    },

    catToggle() {
      if (window.tangleweb.wWidth < 768) {
        this.$categories
          .querySelector('.menu')
          .classList.toggle('open')
      }
    },

    readMore(ev) {
      ev.currentTarget.classList.add('open')

      this.$el
        .querySelector('.desc')
        .classList.add('open')
    },

    resizeHandler() {
      if (window.tangleweb.wWidth < 768 && this.msnry !== undefined) {
        this.msnry.destroy()
        this.msnry = undefined
      } else if (window.tangleweb.wWidth >= 768 && this.msnry === undefined) {
        this.setUpMasonry()
      }
    },

    destroy() {
      console.log('Destroy: shop')

      PubSub.unsubscribe('page.transitionStartDone', this.destroyBinded)
      window.removeEventListener('resize', this.resizeBinded)

      if (this.msnry !== undefined) {
        this.msnry.destroy()
        this.msnry = undefined
      }

      if (this.$readMore !== null) {
        this.$readMore
          .removeEventListener('click', this.readMoreBinded)
      } else if (this.$categories !== null) {
        this.$categories
          .querySelector('.menu-item.active')
          .removeEventListener('click', this.catToggleBinded)
      }
    }
  }

  Object.assign(shop, window.tangleweb)

  shop.init()
  PubSub.subscribe('page.inDOM', shop.init.bind(shop))
})()
